"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const storm_ui_1 = require("@amzn/storm-ui");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const FlexContainer = (0, styled_components_1.default)('div') `
  border-top: 1px solid ${({ theme }) => theme.color.gray[100]};
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding: 10px 18px;
`;
const ApplyButton = (0, styled_components_1.default)(storm_ui_1.Button) `
  margin-inline-start: ${({ theme }) => theme.spacing.xxsmall.default};
`;
const CancelButton = (0, styled_components_1.default)(storm_ui_1.TextButton) `
  padding-right: 5px;
`;
const RegionSelectorFooter = ({ id, onClose, onSelect, }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const cancel = translate('cancel');
    const changeRegionLabel = translate('change-region');
    return ((0, jsx_runtime_1.jsx)(FlexContainer, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CancelButton, { id: `${id}-cancel-button`, onClick: onClose, children: cancel }), (0, jsx_runtime_1.jsx)(ApplyButton, { id: `${id}-change-region-button`, variant: 'primary', onClick: onSelect, children: changeRegionLabel })] }) }));
};
exports.default = RegionSelectorFooter;
//# sourceMappingURL=RegionSelectorFooter.js.map